import {Inject, Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from "@angular/common/http";
import {USER_INFO_CONFIG, USER_PAYMENT_CONFIG} from "../../config/api";

@Injectable({
    providedIn: 'root'
})
export class AccountSettingsPaymentService {
    public visible = new BehaviorSubject(null);
    private config = USER_PAYMENT_CONFIG;

    constructor(private ngZone: NgZone,
                private http: HttpClient) {

    }

    show() {
        this.visible.next(true);

    }

    hide() {
        this.visible.next(false);
    }

    loadData() {
        return this.http.post<any>(this.config.info, {});
    }

    setData(number, expDateMM, expDateYY, securityCode, zipCode, description) {
        return this.http.post<any>(this.config.save, {number, expDateMM, expDateYY, securityCode, zipCode, description});
    }

}
